import { gql } from "@apollo/client";

export const GET_SINGLE_DEACTIVATED_USER = gql`
  query GetSingleDeactivatedUser($userId: Int!) {
    deactivatedAccount(id: $userId) {
      id
      firstName
      lastName
      contactPhoneNumber
      activityPhoneNumber
      timeZone
      summary
      programStartOn
      programEndOn
      createdOn
      deletedAt
    }
  }
`;
